import React, { FunctionComponent } from 'react';
import moment, { Moment } from 'moment';

import { ValueMapperParams, SingleFieldStepProps } from 'scenes/common/types';
import SingleDatePickerStep from 'scenes/common/components/Steps/SingleDatePickerStep';

export const STATE_KEY = 'policyStartDate';
export const QUESTION = 'Select policy start date';
export const HELP_TEXT_60_DAYS =
  'The policy can start any time in the next 60 days.';
export const HELP_TEXT_FIXED_DATE =
  'This policy can start any date before 1 September 2024.';

const getHelpText = (isBeforeEffectiveEndDate: Boolean) =>
  isBeforeEffectiveEndDate ? HELP_TEXT_60_DAYS : HELP_TEXT_FIXED_DATE;

const dateDisplayGenerator = (value: Moment) =>
  `The policy start date is set for the ${moment(value).format(
    'Do MMMM YYYY'
  )}.`;
const bottomLineHelperTexts: ValueMapperParams = [
  dateDisplayGenerator,
  'You will not be covered before this date.',
];

const PolicyStartDateStep: FunctionComponent<
  Pick<SingleFieldStepProps<string>, 'defaultStateValue' | 'onNext'> & {
    isBeforeEffectiveEndDate: Boolean;
  }
> = ({ defaultStateValue, onNext, isBeforeEffectiveEndDate }) => (
  <SingleDatePickerStep
    onNext={onNext}
    question={QUESTION}
    stateKey={STATE_KEY}
    helpText={getHelpText(isBeforeEffectiveEndDate)}
    ariaLabel={QUESTION}
    ariaDescription={getHelpText(isBeforeEffectiveEndDate)}
    isOutsideRange={(date: Moment) =>
      date.isBefore(moment().format('YYYY-MM-DD')) ||
      date.isAfter(moment().add(60, 'day').format('YYYY-MM-DD')) ||
      date.isAfter(moment('2024-09-01').format('YYYY-MM-DD'))
    }
    defaultStateValue={defaultStateValue}
    bottomLineHelperTexts={bottomLineHelperTexts}
  />
);

export default PolicyStartDateStep;
